import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import FormControlLabel from "@mui/material/FormControlLabel"
import Switch from "@mui/material/Switch"
import ModalGeneralInfoSettingsPdfTab from "./CompanyInfo/ModalGeneralInfoSettingsPdfTab"

const EditBrandGeneralTab = ({
  generalInfo,
  setGeneralInfo,
  brandingInfo,
  setBrandingInfo,
  canSetDefault,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        required
        label={i18n.t("trademarkSettings.brandName")}
        size="small"
        variant="outlined"
        value={generalInfo.name}
        onChange={e =>
          setGeneralInfo(prev => ({ ...prev, name: e.target.value }))
        }
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <FormControlLabel
        control={
          <Switch
            checked={generalInfo.isDefault}
            size="small"
            color="primary"
            disabled={!canSetDefault}
            onChange={e =>
              setGeneralInfo(prev => ({
                ...prev,
                isDefault: e.target.checked,
              }))
            }
          />
        }
        label={
          <Typography sx={{ fontSize: "14px", color: "#414141" }}>
            {i18n.t("trademarkSettings.setAsDefault")}
          </Typography>
        }
      />
    </Grid>
    <Grid item xs={12}>
      <ModalGeneralInfoSettingsPdfTab
        userInfo={brandingInfo}
        setUserInfo={setBrandingInfo}
      />
    </Grid>
  </Grid>
)

EditBrandGeneralTab.propTypes = {
  generalInfo: PropTypes.shape({
    name: PropTypes.string,
    isDefault: PropTypes.bool,
  }).isRequired,
  setGeneralInfo: PropTypes.func.isRequired,
  brandingInfo: PropTypes.shape({
    logo: PropTypes.string,
    colorPrimary: PropTypes.string,
    colorSecondary: PropTypes.string,
  }).isRequired,
  setBrandingInfo: PropTypes.func.isRequired,
  canSetDefault: PropTypes.bool,
}

export default EditBrandGeneralTab
